import React from "react";
import { Form, Button, Tab } from "react-bootstrap";
// _includes
import { common, history } from "_helpers";
import { Sms, Activity, Unsubscription } from "../index";

class Logs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: history.location.pathname.split("/")[2],
    };
  }

  componentDidMount() {
    this.checkAccess();
  }

  setTab = (tab) => {
    this.setState({
      activeTab: tab,
    });
    history.push(tab);
  };

  // page access
  checkAccess() {
    const { activeTab } = this.state;
    let pageList = {
      sms: "SMSLOG_PAGEACCESS",
      activity: "ACTIVITYLOG_PAGEACCESS",
      unsubscription: "UNSUBSCRIPTIONLOG_PAGEACCESS",
    };
    if (!common.isAccess(pageList[activeTab])) {
      common.accessDenied();
    } else {
      return true;
    }
  }

  render() {
    const { activeTab } = this.state;
    return (
      <div className="pageContent">
        <Tab.Container activeKey={activeTab}>
          <div className="contentHead">
            <div className="row">
              <div className="col-sm-4 poFlex">
                <h1>Logs</h1>
                <ul>
                  <li>
                    <a href="#">Logs</a>
                  </li>
                  <li>
                    <a href="#" className="noPipe">
                      Overview
                    </a>
                  </li>
                </ul>
              </div>
              <div className="col-sm-8">
                <Form className="poTabs poFlex poDefault">
                  {common.isAccess("SMSLOG_PAGEACCESS") && (
                    <Button
                      variant="primary"
                      className={activeTab != "sms" ? "inActive" : ""}
                      onClick={() => this.setTab("sms")}
                    >
                      SMS
                    </Button>
                  )}
                  {common.isAccess("ACTIVITYLOG_PAGEACCESS") && (
                    <Button
                      variant="primary"
                      className={activeTab != "activity" ? "inActive" : ""}
                      onClick={() => this.setTab("activity")}
                    >
                      Activity
                    </Button>
                  )}
                  {common.isAccess("UNSUBSCRIPTIONLOG_PAGEACCESS") && (
                    <Button
                      variant="primary"
                      className={
                        activeTab != "unsubscription" ? "inActive" : ""
                      }
                      onClick={() => this.setTab("unsubscription")}
                    >
                      Unsubscription
                    </Button>
                  )}
                </Form>
              </div>
            </div>
          </div>
          <div className="contentBody">
            <div className="content">
              <Tab.Content>
                {common.isAccess("SMSLOG_PAGEACCESS") && (
                  <Tab.Pane eventKey="sms" title="SMS">
                    <Sms />
                  </Tab.Pane>
                )}
                {common.isAccess("ACTIVITYLOG_PAGEACCESS") && (
                  <Tab.Pane eventKey="activity" title="Activity">
                    <Activity />
                  </Tab.Pane>
                )}
                {common.isAccess("UNSUBSCRIPTIONLOG_PAGEACCESS") && (
                  <Tab.Pane eventKey="unsubscription" title="Unsubscription">
                    <Unsubscription />
                  </Tab.Pane>
                )}
              </Tab.Content>
            </div>
          </div>
        </Tab.Container>
      </div>
    );
  }
}
export { Logs };
